import moment from 'moment';
import { createContext, useContext, useEffect, useState } from 'react';
import useManualTransactionActions from '../hooks/APIHooks/finance/useManualTransactionActions';
import useTransactionActions from '../hooks/APIHooks/finance/useTransactionActions';
import { ManualTransactionHistory, TransactionHistory } from '../types/history';

// declaring the datatype of the context declared here
interface ITransactionContext {
  isTransactionsLoading: boolean;
  isTransactionsFetching: boolean;
  transactionHistory: Array<TransactionHistory>;
  manualTransactionHistory: Array<ManualTransactionHistory>;
  transactionType: string;
  setTransactionType: React.SetStateAction<React.Dispatch<string>>;
}

// creating the context here
const TransactionContext = createContext<ITransactionContext | null>(null);

const TransactionProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [transactionType, setTransactionType] = useState<string>('gateway');
  const [transactionHistory, setTransactionHistory] = useState<
    Array<TransactionHistory>
  >([]);
  const [manualTransactionHistory, setManualTransactionHistory] = useState<
    Array<ManualTransactionHistory>
  >([]);

  // integration of custom API hooks here
  const { getTransactionListHandler } = useTransactionActions(
    transactionType === 'gateway' ? 'transactionList' : ''
  );

  const { getManualTransactionListHandler } = useManualTransactionActions(
    transactionType === 'manual' ? 'manualTransactionList' : ''
  );

  console.log(
    'MANUAL TRANSACTIONS: ',
    getManualTransactionListHandler.data?.data
  );

  // setting data into local state here
  useEffect(() => {
    setTransactionHistory([]);
    setManualTransactionHistory([]);

    if (transactionType === 'gateway') {
      if (getTransactionListHandler.data?.is_success) {
        setTransactionHistory(
          getTransactionListHandler.data.data.map((transaction) => ({
            ...transaction,
            created_at: moment(transaction.created_at).format('DD-MM-YYYY'),
          }))
        );
      }
    } else {
      if (getManualTransactionListHandler.data?.is_success) {
        setManualTransactionHistory(
          getManualTransactionListHandler.data.data.map((transaction) => ({
            ...transaction,
            transaction_date: moment(transaction.transaction_date).format(
              'DD-MM-YYYY'
            ),
          }))
        );
      }
    }
  }, [
    transactionType,
    getTransactionListHandler.data,
    getManualTransactionListHandler.data,
  ]);

  // rendering the context provider here
  return (
    <TransactionContext.Provider
      value={{
        isTransactionsLoading: getTransactionListHandler.isLoading,
        isTransactionsFetching:
          transactionType === 'gateway'
            ? getTransactionListHandler.isRefetching
            : getManualTransactionListHandler.isRefetching,
        transactionType,
        transactionHistory,
        manualTransactionHistory,
        setTransactionType,
      }}
    >
      {children}
    </TransactionContext.Provider>
  );
};

export default TransactionProvider;

// creating custom hook to access the transaction context here
export const useTransactionContext = () => {
  const context = useContext(TransactionContext);

  if (!context) {
    throw new Error(
      'useTransactionContext must be within TransactionProvider!'
    );
  }

  return context;
};
